import uuid4 from 'uuid/v4';
import uuid5 from 'uuid/v5';
import { downloadFile } from '../Utils/apiHelper';
import { snakeToCamel } from '../Utils/textTools';
import {
  wholesaleV2 as ApiWholesaleV2Service,
  wholesaleV2withMgr as ApiwholesaleV2withMgrService,
  wholesaleV2WithoutPrefix as ApiwholesaleV2withoutPrefixService,
  wholesaleV2withAccount as wholesaleV2withAccountService
} from './ApiService';
import { getXboxPricesMockResponse } from '../Mocks/xboxPricesMock';
import { getCurrentCustomerFromLS, getActiveCurrencyFromLS } from './CoreService';

// function prepareData(items) {
//   return items.map((item) => ({
//     ...item,
//     id: `${item.product_id}:${item.region}`,
//   }));
// }

function newPrepareData(items) {
  return items.map((item) => ({
    ...item,
    id: `${item.productId}:${item.region}`,
  }));
}

function newIdToObject(id) {
  const [productId, region] = id.split(':');

  return {
    productId,
    region,
  };
}

function preparedOrderedItem(item) {
  if (item.products) {
    const currentProducts = [...item.products];
    const newProducts = [];

    currentProducts.forEach((product) => {
      const currentProductInfo = { ...product };
      delete currentProductInfo.items;

      currentProductInfo.countItems = product.items.length;
      currentProductInfo.parentId = `${currentProductInfo.product_id}:${currentProductInfo.region}`;

      product.items.forEach((currentItem, i) => {
        const newData = { ...currentProductInfo, ...currentItem };

        if (i !== 0) {
          delete newData.productId;
          delete newData.region;
          delete newData.game;
        }
        newProducts.push(newData);
      });
    });

    return { ...item, products: newProducts };
  }

  return item;
}

function isLocalPricesMockEnabled() {
  return process.env.NODE_ENV !== 'production'
    && /^(1|true)$/i.test(process.env.REACT_APP_ENABLE_LOCAL_PRICES_MOCK || '');
}

function mapPriceFilters(filters = {}) {
  return Object.keys(filters).reduce((mappedFilters, key) => ({
    ...mappedFilters,
    [snakeToCamel(key)]: Array.isArray(filters[key]) ? filters[key].join(',') : filters[key],
  }), {});
}

function formatPriceListResponse(data) {
  return {
    list: newPrepareData(data.page),
    total: data.total,
  };
}

export default {
  // add currency
  orderGames(pltId, ids, count, maxPrice, orderID, immediate, buyFromStock, cur) {
    const items = ids.map((id) => ({
      ...newIdToObject(id),
      qty: count,
      maxPrice,
      pltId: pltId,
    }));
    const reqId = uuid5(JSON.stringify(items), uuid4());
    const q = `&immediate=${immediate}`;
    const currentCustomer = getCurrentCustomerFromLS();
    const currency = getActiveCurrencyFromLS();
    //https://merchant-router.hoteos.net/api/v2
    return ApiwholesaleV2withoutPrefixService.accessPost(
      `/order?customer_id=${currentCustomer.id}${q}`,
      {
        reqId,
        ext: orderID,
        products: items,
        buyFromStock,
        cur: currency
      }
    );
  },

  orderGamesNonMgr(cur, pltId, ids, count, maxPrice, orderID) {
    const items = ids.map((id) => ({
      ...newIdToObject(id),
      qty: count,
      maxPrice,
      pltId: pltId,
    }));
    const reqId = uuid5(JSON.stringify(items), uuid4());
    const currency = getActiveCurrencyFromLS();

    //https://merchant-router.hoteos.net/api/v2
    return ApiwholesaleV2withoutPrefixService.accessPost(
      `/order`,
      {
        reqId,
        ext: orderID,
        products: items,
        cur: currency
      }
    );
  },

  fetchOrderedList({ filters, orderPath, ...params }) {
    const currentCustomer = getCurrentCustomerFromLS();

    const updatedParams = { ...params };

    if (filters && Object.keys(filters).length) {
      for (const key in filters) {
        updatedParams[snakeToCamel(key)] = Array.isArray(filters[key])
          ? filters[key].join(',')
          : filters[key];
      }
    }

    if (orderPath) {
      updatedParams.order = orderPath.replace('end', '');
    }

    //https://wholesale.hoteos.net/api/v2
    return ApiwholesaleV2withMgrService.get(
      `/orders?customer_id=${currentCustomer.id || '0'}&`,
      updatedParams
    );
  },

  fetchOrderedListNonMgr({ filters, orderPath, ...params }) {

    const updatedParams = { ...params };

    if (filters && Object.keys(filters).length) {
      for (const key in filters) {
        updatedParams[snakeToCamel(key)] = Array.isArray(filters[key])
          ? filters[key].join(',')
          : filters[key];
      }
    }

    if (orderPath) {
      updatedParams.order = orderPath.replace('end', '');
    }

    //https://wholesale.hoteos.net/api/v2
    return wholesaleV2withAccountService.get(
      `/orders`,
      updatedParams
    );
  },

  fetchActiveOrderedList({ filters, orderPath, ...params }) {
    const updatedParams = { ...params };

    if (filters && Object.keys(filters).length) {
      for (let key in filters) {
        if (key === 'from') {
          updatedParams.from = filters.from;
        } else if (key === 'to') {
          updatedParams.to = filters.to;
        } else if (key === 'status') {
          updatedParams.status = filters.status.join(',');
        } else {
          updatedParams[key] = filters[key];
        }
      }
    }

    if (orderPath) {
      updatedParams.order = orderPath.replace('end', '');
    }

    //https://wholesale.hoteos.net/api/v2
    return ApiwholesaleV2withMgrService.get(
      `/orders/active`,
      updatedParams
    );
  },

  //https://wholesale.hoteos.net/api/v2
  fetchRegions() {
    const currentCustomer = getCurrentCustomerFromLS();

    return ApiWholesaleV2Service.accessGet(
      `/xbox/regions?customer_id=${currentCustomer.id || '0'}&`
    );
  },

  fetchRegionsNonMgr() {
    return ApiWholesaleV2Service.accessGet(
      `/xbox/regions`
    );
  },

  // fetchPriceList({ filters = {}, ...params }) {
  //   const currentCustomer = getCurrentCustomerFromLS();
  //   const newFilter = {};

  //   for (const key in filters) {
  //     newFilter[snakeToCamel(key)] = Array.isArray(filters[key])
  //       ? filters[key].join(',')
  //       : filters[key];
  //   }

  //   //https://wholesale.hoteos.net/api/v2
  //   return ApiWholesaleV2Service.accessGet(
  //     `/xbox/prices?customer_id=${currentCustomer.id || '0'}&`,
  //     {
  //       ...params,
  //       ...newFilter,
  //     }
  //   ).then((data) => ({
  //     list: newPrepareData(data.page),
  //     total: data.total,
  //   }));
  // },
  fetchPriceList({ filters = {}, ...params }) {
    const currentCustomer = getCurrentCustomerFromLS();
    const newFilter = mapPriceFilters(filters);
    if (!params.hasOwnProperty("orderBy")) {
      params.orderBy = "salePct";
      params.orderPath = "descend";
    }

    if (isLocalPricesMockEnabled()) {
      return Promise.resolve(
        getXboxPricesMockResponse({
          ...params,
          ...newFilter,
        })
      ).then(formatPriceListResponse);
    }

    if (Object.keys(filters).length > 0) {
      const baseUrl = `/xbox/prices?customer_id=${currentCustomer.id || '0'}`;
      const queryString = new URLSearchParams({
        ...params,
        ...newFilter,
      }).toString();
      const url = `${baseUrl}&${queryString}`;

      return ApiWholesaleV2Service.accessGet(url).then(formatPriceListResponse);
    } else {
      const baseUrl = `/xbox/prices?customer_id=${currentCustomer.id || '0'}`;
      const queryString = new URLSearchParams({
        ...params,
        ...newFilter,
      }).toString();
      const url = `${baseUrl}&${queryString}`;

      return ApiWholesaleV2Service.accessGet(url).then(formatPriceListResponse);
    }
  },

  fetchPriceListNonMgr({ filters = {}, ...params }) {
    const newFilter = mapPriceFilters(filters);
    if (!params.hasOwnProperty("orderBy")) {
      params.orderBy = "salePct";
      params.orderPath = "descend";
    }

    if (isLocalPricesMockEnabled()) {
      return Promise.resolve(
        getXboxPricesMockResponse({
          ...params,
          ...newFilter,
        })
      ).then(formatPriceListResponse);
    }

    if (Object.keys(filters).length > 0) {
      const baseUrl = `/xbox/prices`;
      const queryString = new URLSearchParams({
        ...params,
        ...newFilter,
      }).toString();
      const url = `${baseUrl}?${queryString}`;

      return ApiWholesaleV2Service.accessGet(url).then(formatPriceListResponse);
    } else {
      const baseUrl = `/xbox/prices`;
      const queryString = new URLSearchParams({
        ...params,
        ...newFilter,
      }).toString();
      const url = `${baseUrl}?${queryString}`;

      return ApiWholesaleV2Service.accessGet(url).then(formatPriceListResponse);
    }
  },

  //https://merchant-router.hoteos.net/api/v2
  stopOrder(orderId) {
    return ApiwholesaleV2withoutPrefixService.accessPatch(`/order/${orderId}/stop`);
  },

  //https://merchant-router.hoteos.net/api/v2
  fetchOrderInfo(orderId) {
    return ApiwholesaleV2withoutPrefixService.accessGet(`/order/${orderId}`).then((resp) =>
      preparedOrderedItem(resp)
    );
  },

  fetchOrderForm(orderId) {
    return ApiwholesaleV2withoutPrefixService.accessGet(`/order/${orderId}`).then((resp) =>
      preparedOrderedItem(resp)
    );
  },

  changeOrderPrice(data, orderId) {
    return ApiwholesaleV2withMgrService.accessPatch(
      `/order/${orderId}/items`,
      data
    );
  },

  changeOrderQty(data, orderId) {
    return ApiwholesaleV2withoutPrefixService.accessPatch(
      `/order/${orderId}/items`,
      data
    );
  },

  manualApproveOrder(data, additionalParameters, orderId) {
    return ApiwholesaleV2withMgrService.accessPatch(
      `/order/${orderId}/execute`,
      {
        additionalParameters: additionalParameters,
        items: data
      }

    );
  },

  //https://wholesale.hoteos.net/api/v2
  getInventoryOrder(orderId) {
    const currentCustomer = getCurrentCustomerFromLS();

    return ApiwholesaleV2withMgrService.accessGet(
      `/order/${orderId}/inventory?customer_id=${currentCustomer.id}`
    ).then(downloadFile);
  },

  getInventoryOrderNonMgr(orderId) {
    return ApiwholesaleV2withoutPrefixService.accessGet(
      `/order/${orderId}/inventory`
    ).then(downloadFile);
  },

  getXboxPriceList({ filters = {}, ...params }) {
    const currentCustomer = getCurrentCustomerFromLS();
    const newFilter = {};

    for (const key in filters) {
      newFilter[snakeToCamel(key)] = Array.isArray(filters[key])
        ? filters[key].join(',')
        : filters[key];
    }

    //https://wholesale.hoteos.net/api/v2
    return ApiWholesaleV2Service.accessGet(
      `/xbox/prices/file?customer_id=${currentCustomer.id || '0'}&`,
      {
        ...params,
        ...newFilter,
      }
    ).then(downloadFile);
  },

  //https://merchant-router.hoteos.net/api/v2
  checkKeys(orderId) {
    const currentCustomer = getCurrentCustomerFromLS();

    return ApiwholesaleV2withoutPrefixService.accessPatch(
      `/order/${orderId}/takekeys?customer_id=${currentCustomer.id}`
    );
  },

  //https://merchant-router.hoteos.net/api/v2
  cancelOrder(orderId) {     
    return ApiwholesaleV2withoutPrefixService.accessPatch(`/order/${orderId}/cancel`);
  },

  setFavorite(data) {
    const currentCustomer = getCurrentCustomerFromLS();
    const { action, productId, region } = data;

    //https://wholesale.hoteos.net/api/v2
    return ApiWholesaleV2Service.accessPut(
      `/xbox/prices/tags?customer_id=${currentCustomer.id}`,
      {
        action,
        tags: ['favorites'],
        ids: [{ productId, region }],
      }
    );
  },

  //https://wholesale.hoteos.net/api/v2
  //Platfrom: Xbox = 2
  getQuantityOnStock(pltId, productId, region) {
    return ApiWholesaleV2Service.accessGet(
      `/stock?plt_id=${pltId}&product_id=${productId}&region=${region}`
    );
  },

  updateOrderComment(comment, orderId) {
    return ApiwholesaleV2withMgrService.accessPatch(
      `/order/${orderId}/comment`, comment
    );
  },

  orderVerification(orderId) {
    return ApiwholesaleV2withMgrService.accessPatch(
      `/order/${orderId}/verify`
    );
  },

  approveOrder(orderId) {
    return ApiwholesaleV2withoutPrefixService.accessPatch(
      `/order/${orderId}/approve`
    );
  }
};
